import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cheapestcabserviceinmumbai() {



const cardData = {
  keyword: "Cheapest Cab Service in Mumbai",
  heading: "Lotus Cab: Cheapest Cab Service in Mumbai",

  headingDescription:
    "Lotus Cabs offers the Cheapest Cab Service in Mumbai without compromising on comfort, safety, or reliability. Whether you need an affordable taxi for daily travel, airport transfers, corporate commuting, railway station pickups, local sightseeing, outstation trips, or one-way drops, we provide budget-friendly AC Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus services at transparent and competitive prices. With professional chauffeurs, well-maintained vehicles, 24x7 booking support, doorstep pickup across Mumbai, and no hidden charges, Lotus Cabs ensures a safe, comfortable, and cost-effective travel experience for individuals, families, tourists, and business travelers.",

  top: "Top Places to Visit in Mumbai with Lotus Cab",

 topPlaces: [
    {
        title: "Mumbai Airport",
        description:
            "Mumbai Airport is one of the busiest airports in India, welcoming millions of domestic and international passengers every year. Lotus Cabs offers affordable airport transfer services with timely pickups, flight tracking, comfortable vehicles, and professional drivers, ensuring a smooth and budget-friendly journey to or from Chhatrapati Shivaji Maharaj International Airport."
    },
    {
        title: "Pune",
        description:
            "Pune is among the most popular outstation destinations from Mumbai for business travel, education, family visits, and weekend trips. Lotus Cabs provides low-cost one-way and round-trip taxi services with transparent pricing, allowing travelers to enjoy a comfortable highway journey without exceeding their travel budget."
    },
    {
        title: "Lonavala",
        description:
            "Lonavala is a favorite weekend getaway known for Bhushi Dam, Tiger Point, Karla Caves, lush green valleys, and pleasant weather. Travelers looking for an economical road trip can book affordable cabs with Lotus Cabs and enjoy a relaxing journey through the scenic Mumbai–Pune Expressway."
    },
    {
        title: "Shirdi",
        description:
            "Shirdi attracts thousands of Sai Baba devotees from Mumbai every day. Lotus Cabs offers budget-friendly taxi services for one-way, round-trip, and same-day return journeys, making pilgrimage travel comfortable, safe, and affordable for families, senior citizens, and religious groups."
    },
    {
        title: "Nashik",
        description:
            "Nashik is renowned for Trimbakeshwar Jyotirlinga, Panchavati, Ram Kund, vineyards, and spiritual tourism. Lotus Cabs provides economical cab services from Mumbai to Nashik, allowing travelers to enjoy comfortable transportation for religious tours, wine tourism, and family vacations at competitive prices."
    },
    {
        title: "Mahabaleshwar",
        description:
            "Mahabaleshwar is one of Maharashtra's most scenic hill stations, famous for Venna Lake, strawberry farms, waterfalls, and breathtaking viewpoints. Lotus Cabs offers affordable taxi services that make family holidays, honeymoon trips, and weekend getaways both comfortable and budget-friendly."
    },
    {
        title: "Goa",
        description:
            "Goa is India's most loved beach destination, attracting travelers for holidays, honeymoons, and group vacations. Lotus Cabs provides economical long-distance cab services from Mumbai to Goa with comfortable vehicles, experienced chauffeurs, and transparent pricing for a memorable road trip."
    },
    {
        title: "Alibaug",
        description:
            "Alibaug is a popular coastal destination known for beautiful beaches, sea forts, luxury resorts, and water sports. Travelers can enjoy an affordable beach getaway by booking a budget-friendly cab with Lotus Cabs, ensuring a convenient and relaxing journey from Mumbai."
    },
    {
        title: "Ratnagiri",
        description:
            "Ratnagiri is a picturesque Konkan destination famous for Ganpatipule Temple, pristine beaches, Alphonso mango orchards, and scenic coastal drives. Lotus Cabs offers low-cost outstation taxi services, making it easy for families and tourists to explore the beauty of the Konkan coast comfortably."
    },
    {
        title: "Aurangabad (Chhatrapati Sambhajinagar)",
        description:
            "Aurangabad is home to world-famous attractions including Ajanta Caves, Ellora Caves, Grishneshwar Jyotirlinga, Bibi Ka Maqbara, and Daulatabad Fort. Lotus Cabs provides affordable cab services from Mumbai, helping travelers enjoy heritage tours, pilgrimage journeys, and family vacations with reliable transportation at economical rates."
    }
],

  services: [
    {
      name: "Cheapest Cab in Mumbai",
      description:
        "Affordable cab service in Mumbai designed for daily travel, airport transfers, and short city rides. Transparent per-kilometer pricing ensures cost control. AC sedans and SUVs available at budget rates. Ideal for students, families, and office commuters. No hidden charges included. Professional drivers ensure safe and smooth travel experience."
    },
    {
      name: "Budget Taxi Service Mumbai",
      description:
        "Low-cost taxi booking for local and outstation travel. Clean AC vehicles maintained for comfort. Suitable for daily commutes and business travel. Transparent billing structure shared before confirmation. Economical option without compromising safety."
    },
    {
      name: "Mumbai Airport Cheap Cab",
      description:
        "Pocket-friendly airport pickup and drop service from Mumbai airport. On-time service guaranteed. Ideal for solo travelers and families. Budget AC sedans available."
    },
    {
      name: "Outstation Cheap Cab Mumbai",
      description:
        "Affordable outstation taxi service from Mumbai to nearby cities. One-way and round-trip options available. Highway-ready vehicles ensure smooth travel."
    },
    {
      name: "One Way Cheap Cab Mumbai",
      description:
        "Economical one-way cab service where you pay only for single-side distance. Perfect for relocation and airport transfers."
    },
    {
      name: "Round Trip Cheap Cab Mumbai",
      description:
        "Flexible round-trip package with budget pricing. Suitable for weekend trips and family outings."
    },
    {
      name: "Corporate Budget Cab Mumbai",
      description:
        "Affordable corporate cab solutions for employee transportation and business meetings. Professional chauffeurs included."
    },
    {
      name: "Discount Cab Booking Mumbai",
      description:
        "Special discounted rates for advance booking and long-distance travel. Online booking available 24/7."
    }
  ],

  tableData: [
    ["Cheapest Cab in Mumbai", "Budget Taxi Service Mumbai"],
    ["Low Cost Cab Booking Mumbai", "Affordable Taxi Mumbai"],
    ["Cheap AC Cab Mumbai", "Cheapest Sedan Cab Mumbai"],
    ["Cheapest SUV Cab Mumbai", "Mumbai Airport Cheap Cab"],
    ["Outstation Cheap Cab Mumbai", "One Way Cheap Cab Mumbai"],
    ["Round Trip Cheap Cab Mumbai", "Economy Cab Mumbai"],
    ["Per Km Cheapest Cab Mumbai", "Best Price Taxi Mumbai"],
    ["Discount Cab Booking Mumbai", "Pocket Friendly Cab Mumbai"],
    ["Cheap Online Taxi Mumbai", "Budget Airport Transfer Mumbai"],
    ["Family Budget Cab Mumbai", "Corporate Budget Cab Mumbai"]
  ],

  whychoose: [
    {
      WhyChooseheading: "Lowest Price Guarantee",
      WhyChoosedescription:
        "We offer competitive and affordable pricing for local and outstation travel. Transparent billing ensures no hidden charges. Ideal for budget-conscious travelers."
    },
    {
      WhyChooseheading: "Transparent Per Km Pricing",
      WhyChoosedescription:
        "Clear per-kilometer fare calculation provided before booking confirmation. Customers know exact travel cost in advance."
    },
    {
      WhyChooseheading: "Well-Maintained AC Vehicles",
      WhyChoosedescription:
        "All vehicles are regularly serviced and sanitized. Comfortable seating ensures relaxed travel."
    },
    {
      WhyChooseheading: "Professional Chauffeurs",
      WhyChoosedescription:
        "Experienced drivers ensure safe navigation in Mumbai traffic and highways."
    },
    {
      WhyChooseheading: "24/7 Booking Support",
      WhyChoosedescription:
        "Round-the-clock support team available for booking assistance and queries."
    },
    {
      WhyChooseheading: "Flexible Packages",
      WhyChoosedescription:
        "One-way, round-trip, airport, and outstation travel options available."
    },
    {
      WhyChooseheading: "Budget-Friendly Corporate Plans",
      WhyChoosedescription:
        "Special pricing available for companies and regular business travelers."
    },
    {
      WhyChooseheading: "Quick Online Booking",
      WhyChoosedescription:
        "Instant booking confirmation with easy and hassle-free reservation process."
    }
  ]
};

const faqData = [
  {
    question: "Is this really the cheapest cab service in Mumbai?",
    answer: "Yes, we offer highly competitive rates with transparent per-km pricing and no hidden charges."
  },
  {
    question: "Do you provide cheap airport transfer in Mumbai?",
    answer: "Yes, affordable airport pickup and drop services are available 24/7."
  },
  {
    question: "Are AC vehicles included in budget pricing?",
    answer: "Yes, all our economy cabs are air-conditioned for passenger comfort."
  },
  {
    question: "Is one-way cheap cab available?",
    answer: "Yes, you can book one-way cab and pay only for single-side distance."
  },
  {
    question: "Are SUVs available at budget rates?",
    answer: "Yes, affordable SUV options are available depending on travel requirement."
  },
  {
    question: "Is online booking available?",
    answer: "Yes, instant online cab booking with confirmation support."
  },
  {
    question: "Are drivers professional?",
    answer: "Yes, all chauffeurs are trained, verified, and experienced."
  },
  {
    question: "Do you provide corporate discount?",
    answer: "Yes, special corporate pricing plans are available."
  },
  {
    question: "Is outstation cheap cab available?",
    answer: "Yes, affordable outstation taxi service from Mumbai to nearby cities."
  },
  {
    question: "Is customer support available 24/7?",
    answer: "Yes, our support team is available round-the-clock."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rahul Shah",
    feedback:
      "Very affordable cab service in Mumbai. Transparent pricing and smooth ride. Highly satisfied with budget option.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Priya Verma",
    feedback:
      "Used cheap airport cab service. Driver was punctual and AC vehicle was clean.",
    rating: 5
  },
  {
    id: 3,
    name: "Corporate Client",
    feedback:
      "Booked corporate budget cab plan. Excellent service and cost-effective pricing.",
    rating: 5
  },
  {
    id: 4,
    name: "Mr. Amit Kulkarni",
    feedback:
      "Affordable one-way cab service with no hidden charges. Good experience.",
    rating: 5
  },
  {
    id: 5,
    name: "Mrs. Sneha Patil",
    feedback:
      "Family trip cab booking was budget-friendly and comfortable.",
    rating: 5
  }
];


































































































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];






const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Cheapest Cab Service in Mumbai",
"image": "https://lotuscab.com/assets/images/cheapest-cab-service-in-mumbai.jpg",
"description": "Book Cheapest Cab Service in Mumbai with Lotus Cab for affordable local and outstation travel. Enjoy budget-friendly taxi services with Sedan, SUV, and AC cabs available 24x7 with professional drivers and instant booking confirmation.",
"brand": {
"@type": "Brand",
"name": "Lotus Cab"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "8120"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹10/Km",
"availability": "https://schema.org/InStock",
"url": "https://lotuscab.com/cheapest-cab-service-mumbai"
}
};










  return (
    <div>
      




<Helmet>
  <title>Cheapest Cab Service in Mumbai | Budget Taxi Service | +91 8767592195</title>

<meta
 name="description"
 content="Book Cheapest Cab Service in Mumbai with Lotus Cab for affordable local and outstation rides. Budget-friendly Sedan, SUV, and AC cabs available 24x7 with professional drivers, instant booking, and reliable service."
/>

<meta
 name="keywords"
 content="Cheapest Cab Service in Mumbai, Cheap Cab Mumbai, Budget Taxi Mumbai, Low Cost Cab Service Mumbai, Mumbai Cheapest Taxi, Affordable Cab Mumbai, Mumbai Outstation Cheap Cab, Mumbai Local Cheap Taxi, Best Budget Cab Mumbai, Online Cheap Cab Booking Mumbai, Sedan Cheap Cab Mumbai, SUV Cheap Taxi Mumbai, Mumbai Cab Service Lowest Price, Lotus Cab Mumbai"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>




 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/69.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cheapestcabserviceinmumbai;